import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/api";
import { useT } from "@/lib/i18n";
import Bolt from "@/components/Bolt";
import { openWhatsApp } from "@/components/WhatsAppFloat";

export default function CTA() {
  const { t } = useT();
  return (
    <section data-testid="cta-section" className="relative py-24 sm:py-28">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="relative rounded-3xl overflow-hidden border border-[color:var(--zp-navy-2)]/40 zp-band-navy p-10 sm:p-16 shadow-[0_30px_60px_-30px_rgba(10,37,64,0.5)]">
          <Bolt
            size={420}
            color="#5CE1E6"
            className="absolute -right-16 -top-16 pointer-events-none"
            style={{ opacity: 0.18, transform: "rotate(-12deg)" }}
          />
          <div className="absolute inset-0 zp-grid-bg opacity-[0.15] pointer-events-none" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="zp-label !text-[#5CE1E6]">{t("cta.eyebrow")}</div>
              <h2 className="font-display text-3xl sm:text-5xl tracking-tighter mt-3 leading-[1.05] text-white">
                {t("cta.title.a")}{" "}
                <span className="zp-cyan-text">{t("cta.title.b")}</span>
              </h2>
              <p className="text-[#C9DCE4] mt-5 max-w-xl leading-relaxed">
                {t("cta.subtitle")}
              </p>
            </div>

            <div className="lg:col-span-5 flex flex-col gap-3">
              <Link to="/quote" data-testid="cta-quote" className="zp-btn-cyan">
                {t("common.requestQuote")} <ArrowRight size={16} />
              </Link>
              <Link to="/partner" data-testid="cta-partner" className="inline-flex items-center justify-center gap-2 rounded-full px-5 py-3.5 border border-white/30 bg-white/10 text-white font-semibold hover:bg-white/15 transition">
                {t("common.becomePartner")}
              </Link>
              <a
                data-testid="cta-call"
                href={`tel:${CONTACT.phone}`}
                className="inline-flex items-center justify-center gap-2 rounded-full px-5 py-3.5 border border-white/30 bg-white/10 text-white font-semibold hover:bg-white/15 transition"
              >
                <Phone size={16} /> {t("common.talkOps")}
              </a>
              <button
                data-testid="cta-whatsapp"
                onClick={() => openWhatsApp()}
                className="inline-flex items-center justify-center gap-2 rounded-full px-5 py-3.5 border border-emerald-300/40 bg-emerald-400/15 text-emerald-200 font-semibold hover:bg-emerald-400/25 transition"
              >
                <MessageCircle size={16} /> {t("common.whatsapp")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
